export const SET_PROJECT_ID = 'SET_PROJECT_ID';
export const SET_PROFILE_NAME = 'SET_PROFILE_NAME';
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';
export const SET_PROFILE_EMAIL = 'SET_PROFILE_EMAIL';
export const SET_AUTH = 'SET_AUTH';
export const SET_TB_ID = 'SET_TB_ID';
export const SET_TABLE_DATA = 'SET_TABLE_DATA';
export const SET_FILE_DATA_SHEET = 'SET_FILE_DATA_SHEET';
export const SET_FILE_DATA = 'SET_FILE_DATA';
export const SET_FILTER = 'SET_FILTER';
export const SET_PROJECT_DATA = 'SET_PROJECT_DATA';
export const SET_DELET_ROW = 'SET_DELET_ROW';
export const SET_RESTORE_ROW = 'SET_RESTORE_ROW';
export const SET_DELETED_ROW = 'SET_RESTORE_ROW';
export const SET_CLASSIFICATION = 'SET_CLASSIFICATION';
export const SET_CLASSIFICATIONNAME = 'SET_CLASSIFICATIONNAME';
export const SET_GROUPINGS = 'SET_GROUPINGS';
export const SET_SELECTEDROWS = 'SET_SELECTEDROWS';
export const SET_RESTART = 'SET_RESTART';
export const SET_BLNO = 'SET_BLNO';
export const SET_PLNO = 'SET_PLNO';

//classifcation changes
export const SET_EDITGROUPING = 'SET_EDITGROUPING';
export const SET_EDITSUBGROUPING = 'SET_EDITSUBGROUPING';
export const SET_RENDERNOW = 'SET_RENDERNOW';

//Status check
export const SET_SENDDATA = 'SET_SENDDATA'
export const SET_SENDCY = 'SET_SENDCY'
//second reducer


export const SET_NOTERESTART = 'SET_NOTERESTART';
export const SET_NOTE3 = 'SET_NOTE3';
export const SET_NOTE4 = 'SET_NOTE4';
export const SET_NOTE5 = 'SET_NOTE5';
export const SET_NOTE6A = 'SET_NOTE6A';
export const SET_NOTE6B = 'SET_NOTE6B';
export const SET_NOTE6C = 'SET_NOTE6C';
export const SET_NOTE6D = 'SET_NOTE6D';
export const SET_NOTE6E = 'SET_NOTE6E';
export const SET_NOTE6AA = 'SET_NOTE6AA';
export const SET_NOTE7 = 'SET_NOTE7';
export const SET_NOTE8 = 'SET_NOTE8';
export const SET_NOTE9 = 'SET_NOTE9';
export const SET_NOTE10 = 'SET_NOTE10';
export const SET_NOTE11 = 'SET_NOTE11';
export const SET_NOTE12A = 'SET_NOTE12A';
export const SET_NOTE12B = 'SET_NOTE12B';
export const SET_NOTE12C = 'SET_NOTE12C';
export const SET_NOTE13A = 'SET_NOTE13A';
export const SET_NOTE13B = 'SET_NOTE13B';
export const SET_NOTE13C = 'SET_NOTE13C';
export const SET_NOTE14 = 'SET_NOTE14';
export const SET_NOTE15 = 'SET_NOTE15';
export const SET_NOTE16 = 'SET_NOTE16';
export const SET_NOTE17 = 'SET_NOTE17';
export const SET_NOTE18 = 'SET_NOTE18';
export const SET_NOTE19 = 'SET_NOTE19';
export const SET_NOTE20 = 'SET_NOTE20';
export const SET_NOTE22A = 'SET_NOTE22A';
export const SET_NOTE23 = 'SET_NOTE23';
export const SET_NOTE24 = 'SET_NOTE24';
export const SET_NOTE25 = 'SET_NOTE25';


//template mode reducer

export const SET_SELECTED = 'SET_SELECTED';
// export const SET_NOTERESTART = 'SET_NOTERESTART';
export const SET_NOTETEMP3 = 'SET_NOTETEMP3';
export const SET_NOTETEMP4 = 'SET_NOTETEMP4';
export const SET_NOTETEMP5 = 'SET_NOTETEMP5';
export const SET_NOTETEMP6A = 'SET_NOTETEMP6A';
export const SET_NOTETEMP6B = 'SET_NOTETEMP6B';
export const SET_NOTETEMP6C = 'SET_NOTETEMP6C';
export const SET_NOTETEMP6D = 'SET_NOTETEMP6D';
export const SET_NOTETEMP6E = 'SET_NOTETEMP6E';
export const SET_NOTETEMP6AA = 'SET_NOTETEMP6AA';
export const SET_NOTETEMP7 = 'SET_NOTETEMP7';
export const SET_NOTETEMP8 = 'SET_NOTETEMP8';
export const SET_NOTETEMP9 = 'SET_NOTETEMP9';
export const SET_NOTETEMP10 = 'SET_NOTETEMP10';
export const SET_NOTETEMP11 = 'SET_NOTETEMP11';
export const SET_NOTETEMP12A = 'SET_NOTETEMP12A';
export const SET_NOTETEMP12B = 'SET_NOTETEMP12B';
export const SET_NOTETEMP12C = 'SET_NOTETEMP12C';
export const SET_NOTETEMP13A = 'SET_NOTETEMP13A';
export const SET_NOTETEMP13B = 'SET_NOTETEMP13B';
export const SET_NOTETEMP13C = 'SET_NOTETEMP13C';
export const SET_NOTETEMP14 = 'SET_NOTETEMP14';
export const SET_NOTETEMP15 = 'SET_NOTETEMP15';
export const SET_NOTETEMP16 = 'SET_NOTETEMP16';
export const SET_NOTETEMP17 = 'SET_NOTETEMP17';
export const SET_NOTETEMP18 = 'SET_NOTETEMP18';
export const SET_NOTETEMP19 = 'SET_NOTETEMP19';
export const SET_NOTETEMP20 = 'SET_NOTETEMP20';
export const SET_NOTETEMP22A = 'SET_NOTETEMP22A';
export const SET_NOTETEMP23 = 'SET_NOTETEMP23';
export const SET_NOTETEMP24 = 'SET_NOTETEMP24';
export const SET_NOTETEMP25 = 'SET_NOTETEMP25';